var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.create)?_c('SmsMessageForm',{attrs:{"contact":_vm.contact},on:{"cancel":_vm.onCancel,"created":_vm.onCreated}}):_c('BaseButton',{attrs:{"primary":"","small":""},on:{"click":function($event){_vm.create = true}}},[_vm._v(" New Message ")])
}
var staticRenderFns = []

export { render, staticRenderFns }